import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const styles = (theme: Theme) => {

	return createStyles({
		app_body: {
			background: theme.palette.background.default,
			margin: 'auto',
			display: 'flex',
			flexDirection: 'column',
			height: '100%',
		},
	});
}

export default styles;
